import { doc, getDoc } from 'firebase/firestore';
import { db } from '../lib/firebase';

export enum PermissionError {
  COMPANY_NOT_FOUND = 'COMPANY_NOT_FOUND',
  USER_NOT_LINKED_TO_COMPANY = 'USER_NOT_LINKED_TO_COMPANY'
}

export interface Company {
  id: string;
  name: string;
  [key: string]: any;
}

export interface User {
  uid: string;
  company?: string;
  [key: string]: any;
}

export class DocumentPermissionService {
  /**
   * Fetches company data by ID
   */
  static async fetchCompanyById(companyId: string): Promise<Company | null> {
    try {
      const companyRef = doc(db, 'companies', companyId);
      const companyDoc = await getDoc(companyRef);
      
      if (companyDoc.exists()) {
        return {
          id: companyDoc.id,
          ...companyDoc.data()
        } as Company;
      }
      
      return null;
    } catch (error) {
      return null;
    }
  }

  /**
   * Gets user-friendly error messages
   */
  static getErrorMessage(error: string): string {
    switch (error) {
      case PermissionError.COMPANY_NOT_FOUND:
        return 'Company settings not found. Please contact support.';
      case PermissionError.USER_NOT_LINKED_TO_COMPANY:
        return 'User is not linked to a company. Please contact support.';
      default:
        return 'An error occurred while checking permissions.';
    }
  }
}
